// extracted by mini-css-extract-plugin
export var borderRadius = "_5z-4";
export var large = "_5z-3";
export var logoContainer = "_5z-0";
export var nameLogo = "_5z-2";
export var small = "_5z-1";